// Libraries 
import { combineReducers } from 'redux'
import { routerReducer } from 'react-router-redux'

// Reducers
import { appReducer } from './components/app/reducers'

export const initialState = {
  app: {
    isFetching: true,
    error: null,
    projects: [],
    categories: [],
    selectedCategory: null,
    news: [],
    reviews: [],
    exhibitions: []
  }
}

export const combinedReducers = combineReducers({
  app: appReducer,
  router: routerReducer
})


// WEBPACK FOOTER //
// ./src/reducers.js